module.exports = __webpack_public_path__ + "static/media/logo-martin.a6b36916.jpg";